export const MAX_VAT_EXEMPTION_MENTION_LENGTH = 200
